import { useMutation, useQuery } from "@tanstack/react-query";

import {
  Button,
  Form,
  Image,
  Input,
  Modal,
  Table,
  Typography,
  message,
} from "antd";

import { useState } from "react";
import BackendUpload from "../components/BackendUpload";
import useSearch from "../components/Search";
import {
  addGenres,
  deleteGenres,
  getGenres,
  getImage,
  updateGenres,
} from "../utils/api";
import { useAuth } from "../utils/store";

const Genres = () => {
  const user = useAuth((state) => state.user);
  const [messageApi, contextHolder] = message.useMessage();
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["genres"],
    queryFn: async () => await getGenres(),
  });

  const search = useSearch();

  const { mutate, isLoading: isLoading2 } = useMutation(
    async (values) => await deleteGenres(values),
    {
      onSuccess: () => {
        messageApi.success(`Deleted`);
        refetch();
      },
    }
  );

  console.log(data);

  const columns = [
    {
      title: "S.no",
      dataIndex: "sno",

      render(value, record, index) {
        return index + 1;
      },
    },
    {
      title: "Actions",
      dataIndex: "action",
      render(value, record) {
        return (
          <div>
            <AddData update={record} refech={refetch} />

            {/* <Popconfirm
              title="Delete the task"
              description="Are you sure to delete this task?"
              okText="Yes"
              cancelText="No"
              onConfirm={() => mutate(record._id)}
            >
              <Button danger style={{ marginTop: 10 }} loading={isLoading2}>
                Delete
              </Button>
            </Popconfirm> */}
          </div>
        );
      },
    },

    {
      title: "Name",
      dataIndex: "name",
      ...search("name"),
    },
    {
      title: "Image",
      dataIndex: "image",

      render(value, record) {
        return <Image src={value} width={100} height={100} />;
      },
    },
  ];
  return (
    <div
      style={{
        padding: 24,
      }}
    >
      {contextHolder}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 20,
        }}
      >
        <Typography style={{ fontSize: 20, fontWeight: 600, marginBottom: 10 }}>
          Genres
        </Typography>
        <AddData refech={refetch} />
      </div>
      <Table columns={columns} dataSource={data} loading={isLoading} />
    </div>
  );
};

export default Genres;

const AddData = ({
  refech,

  update,
}) => {
  const [messageApi, contextHolder] = message.useMessage();
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();

  const { mutate, isLoading } = useMutation(
    async (values) =>
      update ? await updateGenres(update._id, values) : await addGenres(values),
    {
      onSuccess: () => {
        messageApi.success(`Added`);
        //reset form
        !update && form.resetFields();
        refech();
        setVisible(false);
      },
      onError: (err) => {
        messageApi.error(err?.response?.data?.message);
      },
    }
  );

  return (
    <div>
      {contextHolder}
      <Button type="primary" onClick={() => setVisible(true)}>
        {update ? "Update" : "Add"}
      </Button>
      <Modal
        title={update ? "Update Genre" : "Add Genre "}
        open={visible}
        onCancel={() => setVisible(false)}
        footer={null}
      >
        <Form
          form={form}
          labelCol={{ span: 6 }}
          layout="horizontal"
          style={{
            maxWidth: 600,
            padding: 20,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
          initialValues={
            update && {
              name: update.name,
            }
          }
          onFinish={(values) => {
            mutate({
              ...values,
              image: getImage(values?.image) ?? update?.image,
            });
          }}
        >
          {" "}
          <Form.Item
            label="Name"
            name="name"
            required
            rules={[
              {
                required: true,
                message: "Please input your name",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <BackendUpload
            label={"Image"}
            type={"photos"}
            name={"image"}
            update={update}
          />
          <Button type="primary" htmlType="submit" loading={isLoading}>
            Submit
          </Button>
        </Form>
      </Modal>
    </div>
  );
};
